import Head from "next/head";
import { BlogList } from "@/components/BlogList";
import { Button } from "@/components/Button";
import {
  getAllCategories,
  getCategoryNameFromSlug,
  getPostsForCategory,
} from "@/lib/posts";
import { Layout } from "@/components/Layout";
import { PageTitle } from "@/components/PageTitle";
import { SectionContainer } from "@/components/SectionContainer";
import { ExternalLinkIcon } from "@heroicons/react/outline";

export const getStaticProps = async ({ params }) => {
  const categoryName = await getCategoryNameFromSlug(params?.category);
  const postsForCategory = await getPostsForCategory(categoryName, true);

  return {
    props: { postsForCategory, categoryName },
    revalidate: 60,
  };
};

export const getStaticPaths = async () => {
  const allCategories = await getAllCategories();

  return {
    paths:
      allCategories.nodes.map((node) => {
        return `/news-archive/categories/${node.slug}`;
      }) || [],
    fallback: false,
  };
};

export default function PostsForCategory({
  postsForCategory: { edges },
  categoryName,
}) {
  const pageTitle = `${categoryName} - Archive`;
  return (
    <>
      <Head>
        <title>{`${pageTitle} - Govern For California`}</title>
        <meta name="robots" content="noindex,nofollow" />
      </Head>
      <Layout mobileTitle={pageTitle}>
        <PageTitle title={pageTitle}>
          <div className="mb-12 items-center sm:my-6 sm:flex sm:justify-center lg:justify-start">
            <Button
              variant="outline"
              xhref="https://action.governforcalifornia.org/a/subscribe"
              target="_blank"
              rel="noreferrer"
            >
              <span className="inline-flex items-center">
                Subscribe
                <ExternalLinkIcon
                  className="-mr-1 ml-[3px] h-3"
                  aria-hidden="true"
                />
              </span>
            </Button>
          </div>
        </PageTitle>
        <SectionContainer
          bgColor={"bg-white"}
          aria-label="Archived posts from Govern For California"
        >
          <BlogList posts={edges} prefix="/news-archive" />
        </SectionContainer>
      </Layout>
    </>
  );
}
